import { render } from "./_idx.vue?vue&type=template&id=28328f98"
import script from "./_idx.vue?vue&type=script&lang=js"
export * from "./_idx.vue?vue&type=script&lang=js"

import "./_idx.vue?vue&type=style&index=0&id=28328f98&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__